import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ExcluirUsuarioMainframeRequest } from './types';

// ACTIONS
import {
	excluirUsuarioMainframeSuccess,
	excluirUsuarioMainframeFailure,
} from './actions';

function* excluirUsuarioMainframe(request: ReducerAction) {
	const { payload }: { payload: ExcluirUsuarioMainframeRequest } = request;
	const { usuario } = payload;

	const token: string = yield select(state => state.user.token.data);

	const response: ApiResponse = yield call(
		deleteApi,
		token,
		PATH_SGU_API,
		`usuarios-mainframe/${usuario}`,
	);

	if (response.status === 200 || response.status === 201) {
		response.data = {
			id: usuario,
		};
		yield put(excluirUsuarioMainframeSuccess(response));
	} else {
		yield put(excluirUsuarioMainframeFailure());
	}
}

export default all([
	takeLatest(Types.EXCLUIR_USUARIO_MAINFRAME_REQUEST, excluirUsuarioMainframe),
]);
